define('views/_base/baseview',["backbone"], function (Backbone) {
    "use strict";

    var BaseView = Backbone.View.extend({
        /*
            TODO: Add descriptions and default values to each option

            OPTIONS:
                - scrollToTop
                - needsAuth
                - elementName
                - render
                - isRender
        */
        initialize: function(context, options){
            context = context || {};
            options = options || {};
            
            var that = this;
            this.context = context;

            //this.loadView(context);

            _.bindAll(context, "handleData");
            _.bindAll(context, "render");

            if(context.scrollToTop != false){
                $(window).scrollTop(0);
            }

            if(context.needsAuth){

                pf.session.on("change:auth", context.handleData, context);

                if(!pf.session.get("auth")){
                    pf.viewLogin();
                    return;
                }
            }

            if(context.elementName){

                context.delegateEvents();
                $(context.elementName).html(context.el);
                //context.setElement($(context.elementName));

            }

            context.render = _.wrap(context.render, function(render){
                
                if(_.isFunction(context.beforeRender)){
                    context.beforeRender();
                }

                context.$el.html('<div class="spinner hasPadding"></div>');

                var rv = render();

                //context.$('.spinner').remove();
                
                if(_.isFunction(context.afterRender)){
                    context.afterRender();
                }

                if(rv){

                    /* 
                        Find all elements within the view containing data-content 
                        attributes and fill in the content (replaces inner html).

                        Example Element: 
                            <button data-content="shared.actionLabels.ok"></button>
                    */ 
                    $('[data-content]', rv.el).each(function(){
                        var $el = $(this),
                        content = pf.getContent( $el.attr('data-content') );
                        $el.html(content).removeAttr('data-content');
                    });

                    /* Fix anchors */
                    $("a", rv.el).each(function(){

                        if(!$(this).attr("data-bypass")){

                            var href = $(this).attr("href");

                            if(!isEmpty(href) && !href.startsWith("http://") && !href.startsWith("https://") && !href.startsWith("//") && !href.startsWith("mailto") && !href.startsWith("tel") && !href.startsWith("pdf")){

                                if(href.startsWith("/")){

                                    href = '#' + href.replace('/', '');

                                } else {

                                    if(!href.startsWith("#")){

                                        href = '#' + href;

                                    }

                                }

                                $(this).attr("href", href);

                            }

                        }

                    });
                }
            });
            if (context.isRender != false) {
                context.render();
                if (_.isFunction(context.loadData)) {
                    if (context.activityIndicator != false) {
                        that.setupActivityIndicator();
                    }
                    context.loadData();
                }
            } else {
                if (_.isFunction(context.loadData)) {
                    context.$el.html('<div class="spinner hasPadding"></div>');
                    context.loadData();
                }
                // context.render();
                if (context.activityIndicator != false) {
                    that.setupActivityIndicator();
                }
            }
        },        
        loadView: function (view, selector) {
            this.cleanup();
            this.currentView = view;
            if (selector)
            this.assign(this.currentView, selector);
        },
        assign: function (view, selector) {
            view.setElement(this.$(selector));
            if (view.isRender != false) {
                view.render();
            }
        },
        
        handleData: function(){
            var that = this;

            if(pf.session.get("auth")){

                // if (this.elementName !== null) {
                if (this.elementName !== null && typeof this.elementName != 'undefined') {
                    this.delegateEvents();
                    $(this.elementName).html(this.el);
                }

                if(that.isRender != false){
                    that.render();
                }

                if(_.isFunction(that.loadData)){
                    that.loadData();
                }
                
            }
        },

        setupActivityIndicator: function () {
            if (this.activityIndicator != false) {
                this.context.$("div.spinner").removeClass("hidden");
            }
        },
        hideActivityIndicator: function () {
            if (this.activityIndicator != false) {
                this.$("div.spinner").addClass("hidden");
            }
        },
        cleanupEvents: function () {
            if (this.needsAuth) {
                pf.session.off("change:auth", this.handleData, this);
            }
        },
        cleanup: function (view) {
            if (view) {
                if (view.needsAuth) {
                    pf.session.off("change:auth", view.handleData, view);
                }
                view.undelegateEvents();
                view.close();
                view = null;
            }
            if (this.currentView) {
                if (this.currentView.needsAuth) {
                    pf.session.off("change:auth", this.currentView.handleData, this.currentView);
                }
                this.currentView.undelegateEvents();
                this.currentView.close();
                this.currentView = null;
            }
        }
    });
    return BaseView;
});

